import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, Card, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useAuth } from '@/app/providers/AuthProvider';
import { changeTenant } from '@/features/auth/api';
import { useState } from 'react';
import { STORAGE_KEYS } from '@/shared/lib/constants';

export const Route = createFileRoute('/_auth/select-tenant')({ component: SelectTenantPage });

function SelectTenantPage() {
  const navigate = useNavigate();
  const { associatedTenants, refresh } = useAuth();
  const [picking, setPicking] = useState<string | null>(null);

  const onPick = async (tenantId: string) => {
    setPicking(tenantId);
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.refreshToken);
      if (!stored) throw new Error('No refresh token');
      await changeTenant(tenantId, stored);
      await refresh();
      void navigate({ to: '/' });
    } catch {
      notifications.show({ color: 'red', message: 'Cambio tenant fallito' });
    } finally {
      setPicking(null);
    }
  };

  return (
    <Stack>
      <Title order={2}>Seleziona la tua azienda</Title>
      <Text c="dimmed" size="sm">
        Hai accesso a più aziende. Scegli quella su cui vuoi lavorare ora.
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2 }}>
        {associatedTenants.map((t) => (
          <Card key={t.tenantId} withBorder padding="lg" radius="md">
            <Stack>
              <Text fw={600}>{t.name}</Text>
              <Button onClick={() => void onPick(t.tenantId)} loading={picking === t.tenantId}>
                Entra
              </Button>
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
